import { Component, inject } from '@angular/core';

import { RouterModule, RouterOutlet, Router } from '@angular/router';
import { ButtonComponent } from '@akostm/orbit-ui';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { WireApiService } from '@frontend/shared';

@Component({
  selector: 'settings-settings',
  standalone: true,
  imports: [RouterModule, RouterOutlet, ButtonComponent, TranslatePipe, FontAwesomeModule],
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent {
  navItems = [
    { label: 'SETTINGS.GENERAL.TITLE', route: 'general' },
    { label: 'SETTINGS.USERS.TITLE', route: 'users' },
    { label: 'SETTINGS.WEBHOOKS.TITLE', route: 'webhooks' },
    { label: 'SETTINGS.MESSAGE_TEMPLATES.TITLE', route: 'message-templates' },
    { label: 'SETTINGS.WORKFLOWS.TITLE', route: 'workflows' },
    { label: 'SETTINGS.CONVERSATION_TYPES.TITLE', route: 'conversation-types' },
    { label: 'SETTINGS.THEME.TITLE', route: 'theme' },
    { label: 'SETTINGS.API_KEYS.TITLE', route: 'api-keys' },
    { label: 'SETTINGS.AUDIT_LOG.TITLE', route: 'audit-log' },
    { label: 'SETTINGS.SMS_SETTINGS.TITLE', route: 'sms-settings' },
  ];

  // Icons
  readonly faBars = faBars;
  readonly faTimes = faTimes;

  // Mobile menu state
  mobileMenuOpen = false;

  readonly #router = inject(Router);
  readonly #translateService = inject(TranslateService);
  readonly #wireApiService = inject(WireApiService);

  constructor() {
    // Ensure translations are loaded
    this.#translateService.setDefaultLang('en');
    this.refreshCredentials();
  }

  closeSettings() {
    this.#router.navigate(['/']);
  }

  onCloseSettingsKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.closeSettings();
    }
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  closeMobileMenu() {
    this.mobileMenuOpen = false;
  }

  onCloseMobileMenuKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.closeMobileMenu();
    }
  }

  refreshCredentials() {
    this.#wireApiService.signInWithStoredCredentials();
  }
}
